/**
 * Blue Chiclets.
 */ var blue = [
    {
        stopColor: '#AD87FF',
        offset: 0
    },
    {
        stopColor: '#7192FF',
        offset: 47.9
    },
    {
        stopColor: '#1AA3FF',
        offset: 100
    }
];

export { blue as default };
//# sourceMappingURL=blue.es.js.map
